import { Component, Input } from '@angular/core';
import { Report } from '../../../../models/report.model';

@Component({
  selector: 'app-valeur-retenue',
  templateUrl: './valeur-retenue.component.html',
  styleUrls: ['./valeur-retenue.component.scss'],
})
export class ValeurRetenueComponent {
  @Input() appraisal!: Report.Appraisal;
}
